import { createSlice } from '@reduxjs/toolkit';
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  activeStep: 0,
  gettingStarted: null,
  contactDetails: null,
  securityDetails: null,
  almostDone: null,
};

const slice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    toggleBusinessOption(state, action) {
      state.business = action.payload;
    },
    setActiveStep(state, action) {
      state.activeStep = action.payload;
    },
    onSubmitGettingStarted(state, action) {
      state.gettingStarted = action.payload;
      state.activeStep = 1;
    },
    onSubmitContactDetails(state, action) {
      state.contactDetails = action.payload;
      // state.activeStep = 2;
    },

    clearData(state, action) {
      state.contactDetails = null;
      state.gettingStarted = null;
      state.activeStep = 0;
    },
    // onSubmitSecurityDetails(state, action) {
    //   state.securityDetails = action.payload;
    //   state.activeStep = 3;
    // },
    // onSubmitAlmostDone(state, action) {
    //   state.almostDone = action.payload;
    //   // state.activeStep = 4
    // },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  toggleBusinessOption,
  setActiveStep,
  onSubmitGettingStarted,
  onSubmitContactDetails,
  clearData,
} = slice.actions;

// ----------------------------------------------------------------------
